export const languageProficiencyOptions = [
    { label: "Beginner", value: 0 },
    { label: "Intermediate", value: 1 },
    { label: "Proficient", value: 2 },
    { label: "Fluent", value: 3 },
    { label: "Native", value: 4 },
];